<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>意见反馈管理</p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <input
          type="text"
          placeholder="标题"
          class="s-input separate"
          v-model="queryInfo.title"
        >
        <select
          class="s-select separate"
          v-model="queryInfo.category"
        >
          <option value="">选择类型</option>
          <option value="1">投诉</option>
          <option value="2">建议</option>
          <option value="3">咨询</option>
        </select>
        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="pageCallback(1)"
        >
      </form>
      <div id="list">
        <table v-if="tableData.length">
          <tr class="l_header">
            <th>用户名</th>
            <th>标题</th>
            <th>内容</th>
            <th>手机号</th>
            <th>联系方式</th>
            <th>类型</th>
            <th>反馈日期</th>
            <th
              class="action"
              width="180"
            >操作</th>
          </tr>
          <tr
            class="item"
            v-for="(item,index) in tableData"
            :key="index"
          >
            <td>{{item.creator ? item.creator.name : ''}}</td>
            <td>{{item.title}}</td>
            <td>{{item.content.length>20?item.content.substr(0, 20)+'...':item.content}}</td>
            <td>{{item.creator ? item.creator.mobile : ''}}</td>
            <td>{{item.connect?item.connect:'--'}}</td>
            <td>{{formatCategory(item.category)}}</td>
            <td>{{formatTime(item.created)}}</td>
            <td class="action">
              <a
                class="edit"
                href="javascript:;"
                @click="viewDetails(item.id)"
              >查看</a>
              <a
                class="edit delete"
                href="javascript:;"
                @click="delDetails(item.id)"
              >删除</a>
            </td>
          </tr>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      :style="classShowFeedBackWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">意见反馈</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require"></i></span>

              <label class="check-label">
                <input
                  class="elevel"
                  type="radio"
                  value="1"
                  disabled
                  v-model="formInfo.category"
                >投诉</label>
              <label class="check-label">
                <input
                  class="elevel"
                  type="radio"
                  value="2"
                  disabled
                  v-model="formInfo.category"
                >建议</label>
              <label class="check-label">
                <input
                  class="elevel"
                  type="radio"
                  value="3"
                  disabled
                  v-model="formInfo.category"
                >咨询</label>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>标题:</span>
              <input
                type="text"
                maxlength="20"
                disabled
                v-model="formInfo.title"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>内容:</span>
              <textarea
                placeholder="请填写具体内容帮助我们了解您的意见和建议"
                maxlength="500"
                v-model="formInfo.content"
                disabled
              ></textarea>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>联系方式:</span>
              <input
                type="text"
                placeholder="请填写您的邮箱地址，以便于我们给您回复"
                maxlength="48"
                v-model="formInfo.connect"
                disabled
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button"
            id="form_close"
            @click="hideFeedBakcWindow"
          >确定</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Feedback',
  components: {
    Pagination
  },
  data() {
    return {
      classShowFeedBackWindow: {},
      queryInfo: {
        page: 1,
        size: 20,
        title: '',
        category: ''
      },
      tableData: [],
      tableDataCount: 0,
      formInfo: {
        category: '',
        title: '',
        content: '',
        connect: ''
      }
    }
  },
  // 计算属性
  computed: {

    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    showFeedBakcWindow() {
      this.classShowFeedBackWindow = {
        visibility: 'visible'
      }
    },
    hideFeedBakcWindow() {
      this.classShowFeedBackWindow = {
        visibility: 'hidden'
      }
    },
    formatTime(val) {
      return val.replace('T', ' ').substring(0, val.indexOf('.'))
    },
    formatCategory(val) {
      if (val === 1) {
        return '投诉'
      } else if (val === 2) {
        return '建议'
      } else {
        return '咨询'
      }
    },
    async search() {
      await this.$http.get('/feedback/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    async viewDetails(id) {
      const url = '/feedback/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = {
          id: id,
          category: data.category,
          title: data.title,
          content: data.content,
          connect: data.connect
        }
        this.showFeedBakcWindow()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('数据获取失败！')
      })
    },
    async delDetails(id) {
      const url = '/feedback/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    }
  },
  mounted() {
    this.search()
  }
}
</script>
<style lang="less" scoped>
textarea {
  min-height: 200px;
  resize: none;
}
.form_control {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  a {
    margin: 0;
  }
}
</style>
